module.exports = __webpack_public_path__ + "icon_kauppa.65fd09a3daef20f33efb.svg";